import { ActionType } from './types';
export const refreshTokenFailed = (error, redirectUrl) => ({
  type: ActionType.REFRESH_TOKEN_FAILED,
  payload: {
    error,
    pathname: redirectUrl
  }
});